import React from "react";

import { styled } from "@mui/material";
import { Outlet } from "react-router-dom";

//styled components
const Root = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2, 4, 2),
}));

const ClientPlansPage: React.FC = () => {
  return (
    <Root>
      <Outlet />
    </Root>
  );
};

export default ClientPlansPage;
